// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__39ET4","right":"styles_right__1evwJ"};